/**
 * Function that generates a unique id
 */
export const generateId = (prefix?: string): string =>
  `${prefix}_${Math.random()
    .toString(36)
    .substr(2, 9)}`;
